var _style, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path2, _ellipse6, _ellipse7, _path3, _path4, _ellipse8, _path5, _path6, _ellipse9, _path7, _ellipse10, _path8, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgP5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M855.7,1000H144.3C64.9,1000,0,935.1,0,855.7V144.3C0,64.9,64.9,0,144.3,0h711.4C935.1,0,1000,64.9,1000,144.3 v711.4C1000,935.1,935.1,1000,855.7,1000z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 76.47,
    rx: 30,
    ry: 26.47
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 288.24,
    rx: 30,
    ry: 26.47
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 500,
    rx: 30,
    ry: 26.47
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 711.76,
    rx: 30,
    ry: 26.47
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 76.47,
    rx: 30,
    ry: 26.47
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200,420.59c-16.57,0-30-11.85-30-26.47V288.23c0-14.62,13.43-26.47,30-26.47s30,11.85,30,26.47v105.88 C230,408.74,216.57,420.59,200,420.59z"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 605.88,
    rx: 30,
    ry: 26.47
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 923.53,
    rx: 30,
    ry: 26.47
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320,420.59c-16.57,0-30-11.85-30-26.47V76.47C290,61.85,303.43,50,320,50s30,11.85,30,26.47v317.65 C350,408.74,336.57,420.59,320,420.59z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M320,738.23c-16.57,0-30-11.85-30-26.47V605.88c0-14.62,13.43-26.47,30-26.47s30,11.85,30,26.47v105.88 C350,726.38,336.57,738.23,320,738.23z"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 440,
    cy: 182.35,
    rx: 30,
    ry: 26.47
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M440,526.47c-16.57,0-30-11.85-30-26.47V394.12c0-14.62,13.43-26.47,30-26.47s30,11.85,30,26.47V500 C470,514.62,456.57,526.47,440,526.47z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M440,950c-16.57,0-30-11.85-30-26.47V711.76c0-14.62,13.43-26.47,30-26.47s30,11.85,30,26.47v211.77 C470,938.15,456.57,950,440,950z"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 560,
    cy: 76.47,
    rx: 30,
    ry: 26.47
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M560,738.23c-16.57,0-30-11.85-30-26.47V500c0-14.62,13.43-26.47,30-26.47s30,11.85,30,26.47v211.76 C590,726.38,576.57,738.23,560,738.23z"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 560,
    cy: 923.53,
    rx: 30,
    ry: 26.47
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M680,738.23c-16.57,0-30-11.85-30-26.47V605.88c0-14.62,13.43-26.47,30-26.47s30,11.85,30,26.47v105.88 C710,726.38,696.57,738.23,680,738.23z"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 800,
    cy: 76.47,
    rx: 30,
    ry: 26.47
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 800,
    cy: 288.24,
    rx: 30,
    ry: 26.47
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 800,
    cy: 500,
    rx: 30,
    ry: 26.47
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 800,
    cy: 711.76,
    rx: 30,
    ry: 26.47
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 800,
    cy: 923.53,
    rx: 30,
    ry: 26.47
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M920,420.59c-16.57,0-30-11.85-30-26.47V288.23c0-14.62,13.43-26.47,30-26.47c16.57,0,30,11.85,30,26.47v105.88 C950,408.74,936.57,420.59,920,420.59z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M920,844.11c-16.57,0-30-11.85-30-26.47V711.76c0-14.62,13.43-26.47,30-26.47c16.57,0,30,11.85,30,26.47v105.88 C950,832.27,936.57,844.11,920,844.11z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP5);
export default __webpack_public_path__ + "static/media/P5.04fa4e1f7d764ca72be61c4629062c05.svg";
export { ForwardRef as ReactComponent };